import { connect } from 'react-redux';

import Actions from '../../Actions/Creators';
import DialogTalkToExpert from './Component/DialogTalkToExpert';


const mapStateToProps = (state, ownProps) => ({
    isLoading: state.expertQuery.isLoading,
    postStatus: state.expertQuery.status,
    error: state.expertQuery.error,

    user: state.auth.userProfile,
    childList: state.child.childList,
    selectedChild: state.child.selectedChild
});


const mapDispatchToProps = (dispatch) => ({
    resetExpertQuery: () => dispatch(Actions.resetExpertQueries()),
    postExpertQuery: (params) => dispatch(Actions.postExpertQueries(params))
});


export default connect(mapStateToProps, mapDispatchToProps)(DialogTalkToExpert)